import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-down\"><defs><style type=\"text/css\"></style></defs><path d=\"M715.1 423L511.7 626.4 308.3 423c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L485.7 691c0.9 1.2 2 2.4 3.1 3.6 6.3 6.3 14.6 9.4 22.9 9.4 8.3 0.1 16.6-3.1 22.9-9.4 1.1-1.1 2.2-2.3 3.1-3.6l222.7-222.7c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z\" p-id=\"2171\" fill=\"#232323\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol